/* eslint import/prefer-default-export: 0 */
import { Buffer } from "buffer";

export function urlSafeB64Encode(s) {
  const b64 = Buffer.from(s, "utf-8").toString("base64");
  return b64.replaceAll("+", "-").replaceAll("/", "_").split("=")[0];
}
